import { tableConfig } from '../../tables';

export const AgGridPage = {
  Tables: {
    [tableConfig.AUTHORS_WORK.name]: 'Dela',
    [tableConfig.MONITORING.name]: 'Emitovanje',
    [tableConfig.CODE_CODEBOOK_TYPES.name]: 'Šifarnici',
    [tableConfig.CODE_CODEBOOKS.name]: 'Šifre',
    [tableConfig.CODE_CHILDREN_CODEBOOKS.name]: 'Prikaz dece od šifre',
  },
  Tooltips: {
    active: 'Aktivan',
    inactive: 'Deaktiviran',
    rerouting: 'Prelazak na drugu stranu',
    аction: 'Modal akcija',
  },
  ActiveFilter: {
    statusTitle: 'Stanje filtera: ',
    off: 'Isključen',
    clear: 'Obriši',
  },
  CellRender: {
    Boolean: { inactive: 'Neaktivan', active: 'Aktivan' },
  },
  Header: {
    useSelectedRowLabel: 'Primeni izabrani red',
    quickSearchLabel: 'Globalna pretraga',
    exportLabel: 'Izvezi podatke',
    exportButtonTooltip:
      'Izvoz podataka se odnosi na selektovane redove u tabelarnom prikazu',
    clearFilters: 'Obriši filtere',
    changeFilterTooltip: 'Izmena atributa za pretragu',
    changeFilterTooltipDisabled:
      'Izmena atributa za pretragu nije moguća ukoliko su filteri aktivni',
    changeTableTooltip: 'Izmena tabelarnog prikaza',
    clearFiltersTooltip:
      'Brisanje svih filtera koji su primenjeni nad kolonama u tabeli u okviru tabelarnog prikaza',
  },
  Footer: { rowsLabel: 'Broj redova' },
  ModalForExport: {
    title: 'Izvezi podatke',
    typeOfExportPlaceholder: 'Tip',
    buttonLabel: 'Izvezi',
    Errors: {
      typeOfExport: 'Potrebno je odabrati tip za izvoz podataka',
    },
    NotificationMessages: {
      exportTitle: 'Izvoz podataka',
      successExport: 'Izvoz podataka je uspešno izvršen',
    },
  },
  ValidityPeriodModal: {
    createTitle: 'Ugovori - Unos važenja mesta korišćenja',
    updateTitle: 'Ugovori - Izmena važenja mesta korišćenja',
    dateFrom: 'Početak korišćenja u mestu korišćenja',
    dateTo: 'Završetak korišćenja u mestu korišćenja',
    createButton: 'Unos važenja mesta korišćenja',
    updateButton: 'Izmena važenja mesta korišćenja',
    Errors: {
      dateFrom: 'Potrebno je uneti početak korišćenja',
    },
    NotificationMessages: {
      objectTitle: 'Objekat',
      broadcasterTitle: 'Kanal emitera',
      rebroadcasterTitle: 'Paket reemitera',
      successObjectUpdate: 'Mesto korišćenja - Objekat je uspešno izmenjen',
      successBroadcasterUpdate:
        'Mesto korišćenja - Kanal emitera je uspešno izmenjen',
      successRebroadcasterUpdate:
        'Mesto korišćenja - Paket reemitera je uspešno izmenjen',
      datesAlreadyDeclared:
        ' već ima(ju) definisan period važenja. Potrebno je izvršiti ispravnu selekciju',
    },
  },
  NotificationMessages: {
    errorTitle: 'Greška',
    infoTitle: 'Info',
    notChosen: 'Nije odabran nijedan atribut',
    notFound: 'Ne postoji atribut prema traženom filteru',
    notExist: 'Ne postoje atributi za prikazanu tabelu',
    infoMessage: 'Nije pronađen nijedan rekord',
    unselectRowMessage: 'Potrebno je izabrati red',
    unsuccessfulSelectMessage: 'Moguće je odabrati samo pravno lice',
  },
  Pagination: {
    from: 'od',
    to: 'do',
    page: 'Stranica',
  },
  Labels: {
    selectAll: '(Izaberite sve)',
    selectAllSearchResults: '(Izaberite sve rezultate pretrage)',
    searchOoo: 'Pretraži...',
    blanks: '(Blanks)',
    noMatches: 'Nema rezultata',

    // Number Filter & Text Filter
    filterOoo: 'Filter...',
    equals: 'Jednako',
    notEqual: 'Različito',
    empty: 'Izaberite jedno',
    blank: 'Prazno',
    notBlank: 'Nije prazno',

    // Number Filter
    lessThan: 'Manje od',
    greaterThan: 'Veće od',
    lessThanOrEqual: 'Manje od ili jednako',
    greaterThanOrEqual: 'Veće od ili jednako',
    inRange: 'U opsegu',
    inRangeStart: 'od',
    inRangeEnd: 'do',

    // Text Filter
    contains: 'Sadrži',
    notContains: 'Ne sadrži',
    startsWith: 'Počinje sa',
    endsWith: 'Završava se sa',

    // Date Filter
    dateFormatOoo: 'dd.mm.gggg',

    // Filter Conditions
    andCondition: 'I',
    orCondition: 'ILI',

    // Filter Buttons
    applyFilter: 'Primeni',
    resetFilter: 'Restart',
    clearFilter: 'Obriši',
    cancelFilter: 'Poništi',

    // Filter Titles
    textFilter: 'Tekstualni filter',
    numberFilter: 'Brojevni filter',
    dateFilter: 'Datum filter',
    setFilter: 'Set filter',

    // Side Bar
    columns: 'Kolone',
    filters: 'Filteri',

    // columns tool panel
    pivotMode: 'Pivot mod',
    groups: 'Grupe redova',
    rowGroupColumnsEmptyMessage:
      'Prevucite ovde da biste postavili grupe redova',
    values: 'Vrednosti',
    valueColumnsEmptyMessage: 'Prevucite ovde da biste agregirali',
    pivots: 'Kolone labela',
    pivotColumnsEmptyMessage: 'Prevucite ovde da biste postavili oznake kolona',

    // Header of the Default Group Column
    group: 'Grupa',

    // Other
    loadingOoo: 'Učitavanje...',
    noRowsToShow: 'Nema rekorda za prikaz...',
    enabled: 'Omogućeno',

    // Menu
    pinColumn: 'Pinovanje kolone',
    pinLeft: 'Pinovanje sa leve strane',
    pinRight: 'Pinovanje sa desne strane',
    noPin: 'Ukloni pinovanje',
    valueAggregation: 'Value Aggregation',
    autosizeThiscolumn: 'Automatska veličina ove kolone',
    autosizeAllColumns: 'Automatska veličina svih kolona',
    groupBy: 'Grupiši po',
    ungroupBy: 'Razdvoji po',
    resetColumns: 'Resetuj kolone',
    expandAll: 'Raširi sve',
    collapseAll: 'Zatvori sve',
    copy: 'Kopiraj',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Kopiraj sa hederom',
    copyWithGroupHeaders: 'Kopiraj sa grupom hedera',
    paste: 'Nalepi',
    ctrlV: 'Ctrl+V',
    export: 'Izvezi podatke',
    csvExport: 'Izvoz podataka u CSV',
    excelExport: 'Izvoz podataka u Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Suma',
    min: 'Minimalno',
    max: 'Maksimalno',
    none: 'Različito',
    count: 'Broj',
    avg: 'Prosek',
    filteredRows: 'Filtrirano',
    selectedRows: 'Selektovano',
    totalRows: 'Ukupno redova',
    totalAndFilteredRows: 'Redovi',
    more: 'Više',
    to: 'do',
    of: 'od',
    page: 'Strana',
    nextPage: 'Sledeće strana',
    lastPage: 'Poslednja strana',
    firstPage: 'Početna strnaa',
    previousPage: 'Prethodna strana',

    // Pivoting
    pivotColumnGroupTotals: 'Укупно',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',

    line: 'Line',

    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart',

    // ARIA
    ariaHidden: 'hidden',
    ariaVisible: 'visible',
    ariaChecked: 'checked',
    ariaUnchecked: 'unchecked',
    ariaIndeterminate: 'indeterminate',
    ariaDefaultListName: 'List',
    ariaColumnSelectAll: 'Toggle Select All Columns',
    ariaInputEditor: 'Input Editor',
    ariaDateFilterInput: 'Date Filter Input',
    ariaFilterList: 'Filter List',
    ariaFilterInput: 'Filter Input',
    ariaFilterColumnsInput: 'Filter Columns Input',
    ariaFilterValue: 'Filter Value',
    ariaFilterFromValue: 'Filter from value',
    ariaFilterToValue: 'Filter to value',
    ariaFilteringOperator: 'Filtering Operator',
    ariaColumn: 'Column',
    ariaColumnList: 'Column List',
    ariaColumnGroup: 'Column Group',
    ariaRowSelect: 'Press SPACE to select this row',
    ariaRowDeselect: 'Press SPACE to deselect this row',
    ariaRowToggleSelection: 'Press Space to toggle row selection',
    ariaRowSelectAll: 'Press Space to toggle all rows selection',
    ariaToggleVisibility: 'Press SPACE to toggle visibility',
    ariaSearch: 'Search',
    ariaSearchFilterValues: 'Search filter values',

    // ARIA LABEL FOR DIALOGS
    ariaLabelCellEditor: 'Cell Editor',
    ariaLabelDialog: 'Dialog',
    ariaLabelSelectField: 'Select Field',
    ariaLabelTooltip: 'Tooltip',
    ariaLabelContextMenu: 'Context Menu',
    ariaLabelColumnMenu: 'Column Menu',
    ariaLabelSubMenu: 'SubMenu',
    ariaLabelAggregationFunction: 'Aggregation Function',
  },
};

export const AttributeFilters = {
  CONTAINS: {
    text: 'Sadrži',
    value: 'CONTAINS',
    type: ['number', 'text'],
    index: '0',
  },
  NOT_CONTAINS: {
    text: 'Ne sadrži',
    value: 'NOT_CONTAINS',
    type: ['number', 'text'],
    index: '1',
  },
  EQUAL: {
    text: 'Jednako',
    value: 'EQUAL',
    type: ['text', 'object'],
    index: '2',
  },
  NOT_EQUAL: {
    text: 'Nije jednako',
    value: 'NOT_EQUAL',
    type: ['text', 'object'],
    index: '3',
  },
  STARTS_WITH: {
    text: 'Početi sa',
    value: 'STARTS_WITH',
    type: ['text'],
    index: '4',
  },
  ENDS_WITH: {
    text: 'Završava sa',
    value: 'ENDS_WITH',
    type: ['text'],
    index: '5',
  },
  EMPTY: {
    text: 'Prazno',
    value: 'EMPTY',
    type: ['text'],
    index: '5',
  },
  NOT_EMPTY: {
    text: 'Nije prazno',
    value: 'NOT_EMPTY',
    type: ['text'],
    index: '6',
  },
  LESS_THAN: {
    text: 'Manje od',
    value: 'LESS_THAN',
    type: ['number'],
    index: '7',
  },
  GREATER_THAN: {
    text: 'Veće od',
    value: 'GREATER_THAN',
    type: ['number'],
    index: '8',
  },
  LESS_THAN_EQUAL: {
    text: 'Manje ili jednako',
    value: 'LESS_THAN_EQUAL',
    type: ['number'],
    index: '9',
  },
  GREATER_THAN_EQUAL: {
    text: 'Veće ili jednako',
    value: 'GREATER_THAN_EQUAL',
    type: ['number'],
    index: '10',
  },
  IN_RANGE: {
    text: 'U opsegu',
    value: 'IN_RANGE',
    type: ['number'],
    index: '11',
  },
  IS_ON: {
    text: 'Jednak',
    value: 'IS_ON',
    type: ['date'],
    index: '12',
  },
  IS_NOT_ON: {
    text: 'Nije jednak',
    value: 'IS_NOT_ON',
    type: ['date'],
    index: '13',
  },
  IS_AFTER: {
    text: 'Veći od',
    value: 'IS_AFTER',
    type: ['date'],
    index: '14',
  },
  IS_BEFORE: {
    text: 'Manji od',
    value: 'IS_BEFORE',
    type: ['date'],
    index: '15',
  },
  IS_ON_OR_AFTER: {
    text: 'Veći ili jednak',
    value: 'IS_ON_OR_AFTER',
    type: ['date'],
    index: '16',
  },
  IS_ON_OR_BEFORE: {
    text: 'Manji ili jednak',
    value: 'IS_ON_OR_BEFORE',
    type: ['date'],
    index: '17',
  },
  IS_TRUE: {
    text: 'Tačno',
    value: 'IS_TRUE',
    type: ['boolean'],
    index: '18',
  },
  IS_FALSE: {
    text: 'Nije tačno',
    value: 'IS_FALSE',
    type: ['boolean'],
    index: '19',
  },
};

export const AttributeRadioButton = {
  AND: {
    text: 'I',
    value: 'AND',
    index: '0',
  },
  OR: {
    text: 'ILI',
    value: 'OR',
    index: '1',
  },
};

export const AttributeView = {
  title: 'Pretraga',
  Placeholders: {
    filter: 'Filter',
    from: 'Od',
    to: 'Do',
    criteria: 'Kriterijum',
    date: 'Datum',
    search: 'Pretraga',
    0: 'Sve',
    50: '50',
    100: '100',
    200: '200',
    numberOfResults: 'Broj prikazanih rezultata',
    attributes: 'Odaberite atribute po kojima želite da filtrirate rezultate',
  },
  NotificationMessages: {
    errorTitle: 'Greška',
    infoTitle: 'Info',
    notChosen: 'Nije odabran nijedan atribut',
    notFound: 'Ne postoji atribut prema traženom filteru',
    notExist: 'Ne postoje atributi za prikazanu tabelu',
    infoMessage: 'Nije pronađen nijedan rekord',
    notFoundRecords:
      'Nema podataka za prikaz, za izabrane kriterijume pretrage',
  },
  Errors: {
    missingCriteria: 'Nije unet kriterijum pretrage',
    missingNumberTo: 'Nije unet broj do',
    numberToLess: 'Broj do je manji od broja od',
    numberFromBigger: 'Broj od je veći od broja do',
    dateToLess: 'Datum do je manji od datuma od',
    dateFromBigger: 'Datum od je veći od datuma do',
  },
};
